var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"noncooperation-page"},[_c('p',[_vm._v("当前登录账号为非合作状态，暂无查看该页面权限")])])}]

export { render, staticRenderFns }